/* eslint-disable  */

export const stringToBool = (stringVal: 'TRUE' | 'FALSE') => {
  return stringVal === 'TRUE'
}
